import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ title, data, labels, color = '#3B82F6' }) => {
  const chartData = useMemo(() => ({
    labels: labels,
    datasets: [
      {
        label: title,
        data: data,
        backgroundColor: color,
        borderRadius: 6,
        borderSkipped: false,
      },
    ],
  }), [labels, data, title, color]);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 200,
    animation: false,
    transitions: {
      resize: {
        animation: {
          duration: 0
        }
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#0F172A',
        padding: 12,
        cornerRadius: 8,
        titleFont: {
          family: 'Inter',
          size: 13,
          weight: '600',
        },
        bodyFont: {
          family: 'Inter',
          size: 14,
          weight: '500',
        },
        callbacks: {
          label: function(context) {
            return `${context.parsed.y.toFixed(1)}%`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            family: 'Inter',
            size: 12,
            weight: '500',
          },
          color: '#6B7280',
        },
      },
      y: {
        grid: {
          color: '#F1F5F9',
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            family: 'Inter',
            size: 12,
            weight: '500',
          },
          color: '#6B7280',
          callback: function(value) {
            return value + '%';
          },
        },
      },
    },
  }), []);

  return (
    <div data-testid="bar-chart" className="bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-200 p-6">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">{title}</h3>
      <div className="relative w-full" style={{ height: '360px', minHeight: '360px', maxHeight: '360px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default React.memo(BarChart);